import { GET_NOTE_CREATED_RESPONSE, GET_SECTIONS_TO_UPDATE } from '../actions'
import { logger } from '../../lib/logging'

const defaults = {
  sectionsToUpdate: [],
  compBeingCreated: false,
  compBeingDeleted: false,
  submissionStatus: null,
  addPbSection: false,
  keyboardMode: false,
  deleteCompResponse: {
    __typename: 'DeleteCompResponse',
    isCompDeleted: false,
    error: false
  },
  noteCreatedResponse: {
    __typename: 'NoteCreatedResponse',
    isPending: false,
    composition: '',
    error: false,
    id: ''
  },
  sectionBeingDeleted: {
    __typename: 'SectionBeingDeleted',
    id: ''
  },
  composition: '',
  newComposition: '',
  currentNotetypeId: ''
}

const resolvers = {
  Mutation: {
    setSectionsToUpdate: (_, { sectionsToUpdate }, { cache }) => {
      const { sectionsToUpdate: oldStu } = cache.readQuery({ query: GET_SECTIONS_TO_UPDATE })
      const newIds = sectionsToUpdate.map(stu => stu.id)
      logger.info(`[RESOLVER] Adding sections to update: ${newIds.join(', ')}`)
      console.debug(`[RESOLVER] Adding sections to update: ${newIds.join(', ')}`)
      const newStu = [...oldStu, ...sectionsToUpdate]
      const data = { sectionsToUpdate: newStu }
      const ids = newStu.map(stu => stu.id)
      logger.info(`[RESOLVER] New set of sections to update: ${ids.join(', ')}`)
      console.debug(`[RESOLVER] New set of sections to update: ${ids.join(', ')}`)
      cache.writeData({ data })
      return null
    },
    removeSectionToUpdate: (_, { sectionIdToRemove }, { cache }) => {
      logger.info(`[RESOLVER] Removing section to update: ${sectionIdToRemove}`)
      console.debug(`[RESOLVER] Removing section to update: ${sectionIdToRemove}`)
      const { sectionsToUpdate } = cache.readQuery({ query: GET_SECTIONS_TO_UPDATE })
      const stuCopy = [...sectionsToUpdate]
      const removeIdx = stuCopy.findIndex(stu => stu.id === sectionIdToRemove)
      if (removeIdx > -1) stuCopy.splice(removeIdx, 1)
      const remainingIds = stuCopy.map(stu => stu.id)
      if (remainingIds.length > 0) {
        logger.info(`[RESOLVER] Remaining sections to update: ${remainingIds.join(', ')}`)
        console.debug(`[RESOLVER] Remaining sections to update: ${remainingIds.join(', ')}`)
      } else {
        logger.info('[RESOLVER] No remaining sections to update')
        console.debug('[RESOLVER] No remaining sections to update')
      }
      const data = { sectionsToUpdate: stuCopy }
      cache.writeData({ data })
      return null
    },
    clearSectionsToUpdate: (_, { reason }, { cache }) => {
      logger.info(`[RESOLVER] Clearing sections to update${reason ? ` due to ${reason}` : ''}`)
      console.debug(`[RESOLVER] Clearing sections to update${reason ? ` due to ${reason}` : ''}`)
      const data = { sectionsToUpdate: defaults.sectionsToUpdate }
      cache.writeData({ data })
      return null
    },
    setComposition: (_, { composition }, { cache }) => {
      const data = {
        composition
      }
      logger.info(`[RESOLVER] Setting composition with id: ${composition.id}`)
      cache.writeData({ data })
      return null
    },
    setCurrentNotetypeId: (_, { id }, { cache }) => {
      const data = {
        currentNotetypeId: id
      }
      logger.info(`[RESOLVER] Setting current notetype id: ${id}`)
      cache.writeData({ data })
      return null
    },
    setCompBeingCreated: (_, { compBeingCreated }, { cache }) => {
      const data = { compBeingCreated }
      logger.info(`[RESOLVER] Setting comp being created: ${compBeingCreated}`)
      cache.writeData({ data })
      return null
    },
    setCompBeingDeleted: (_, { compBeingDeleted }, { cache }) => {
      const data = { compBeingDeleted }
      logger.info(`[RESOLVER] Setting comp being deleted: ${compBeingDeleted}`)
      cache.writeData({ data })
      return null
    },
    setSubmissionStatus: (_, { status }, { cache }) => {
      const data = { submissionStatus: status }
      logger.info(`[RESOLVER] Setting submission status: ${status}`)
      cache.writeData({ data })
      return null
    },
    clearSubmissionStatus: (_, args, { cache }) => {
      const data = { submissionStatus: defaults.submissionStatus }
      logger.info('[RESOLVER] Clearing submission status')
      cache.writeData({ data })
      return null
    },
    setAddPbSection: (_, __, { cache }) => {
      const data = { addPbSection: true }
      logger.info('[RESOLVER] Setting add pb section')
      cache.writeData({ data })
      return null
    },
    clearAddPbSection: (_, __, { cache }) => {
      const data = { addPbSection: false }
      logger.info('[RESOLVER] Clearing add pb section')
      cache.writeData({ data })
      return null
    },
    setKeyboardMode: (_, __, { cache }) => {
      const data = { keyboardMode: true }
      logger.info('[RESOLVER] Setting keyboard mode')
      cache.writeData({ data })
      return null
    },
    clearKeyboardMode: (_, __, { cache }) => {
      const data = { keyboardMode: false }
      logger.info('[RESOLVER] Clearing keyboard mode')
      cache.writeData({ data })
      return null
    },
    setDeleteCompRes: (_, { status }, { cache }) => {
      const data = {
        deleteCompResponse: {
          __typename: 'DeleteCompResponse',
          isCompDeleted: status === true,
          error: status === false
        }
      }
      cache.writeData({ data })
      return null
    },

    setSectionBeingDeleted: (_, { id }, { cache }) => {
      const data = {
        sectionBeingDeleted: {
          __typename: 'SectionBeingDeleted',
          id: id

        }
      }
      cache.writeData({ data })
      return null
    },
    setNoteCreatedResponse: (_, { isPending, composition, error, id }, { cache }) => {
      const { noteCreatedResponse } = cache.readQuery({ query: GET_NOTE_CREATED_RESPONSE })

      const newNoteCreatedResponse = { ...noteCreatedResponse }

      if (isPending !== undefined) {
        newNoteCreatedResponse.isPending = isPending
      }

      if (composition !== undefined) {
        newNoteCreatedResponse.composition = composition
      }

      if (error !== undefined) {
        newNoteCreatedResponse.error = error
      }

      if (id !== undefined) {
        newNoteCreatedResponse.id = id
      }

      const data = {
        noteCreatedResponse: newNoteCreatedResponse
      }

      cache.writeData({ data })
      return null
    }
  }
}

export default { defaults, resolvers }
